import { defineAsyncComponent } from 'vue';

export { default as EliHeadWithShadow } from './components/EliHeadWithShadow.vue';
export * from './components/EliInsights';
export type { EliContextData } from './types';

export const eliMicroFrontends = {
	EliInsightsFeedback: defineAsyncComponent(
		() => import('./components/EliInsightsFeedback/EliInsightsFeedback.vue')
	),
	EliSettings: defineAsyncComponent(
		() => import('./components/EliSettings/EliSettings.vue')
	),
};
